import _ from 'lodash-es';
import QRCode from 'qrcode';

export default class QrCodeGeneratorController {
	#canvas;

	/* @ngInject */
	constructor($element, $scope) {
		this.$element = $element;
		this.$scope = $scope;
		this.value = undefined;
		this.options = undefined;
		this.#canvas = undefined;
	}

	$onInit() {
		if (!this.options) {
			this.options = {
				// errorCorrectionLevel: 'H',
			};
		}
		this.$scope.$watch('$ctrl.options', (options, oldOptions) => {
			if (!_.isEqual(options, oldOptions)) {
				this.generateCode();
			}
		}, true);
	}

	generateCode() {
		this.#canvas = this.$element.find('.qrgen');
		if (this.#canvas?.length > 0 && this.value && typeof this.value === 'string') {
			QRCode.toCanvas(this.#canvas[0], this.value, this.options, error => {
				if (error) {
					console.error(error);
				}
			});
		}
	}

	$onChanges(changes) {
		if (changes.value) {
			this.generateCode();
		}
	}
}
